<template>
    <div @click="toggleCheck">
        <IconItem icon="mdi:checkbox-marked" v-if="isChecked" />
        <IconItem icon="mdi:checkbox-blank-outline" v-else />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "CustomCheck",

    data: function () {
        return {
            isChecked: false,
        };
    },
    methods: {
        toggleCheck() {
            this.isChecked = !this.isChecked;
        },
    },
});
</script>

<style scoped>
div {
    cursor: pointer;
}

i {
    color: var(--blue-terrascribe);
}
</style>
